

import React from 'react';
import '../css/CircleProgress.css';

// Helper to describe an SVG arc (for a filled pie segment)
function describeArc(cx, cy, r, percent) {
    const angle = (percent / 100) * 360;
    const radians = (angle - 90) * Math.PI / 180.0;
    const x = cx + r * Math.cos(radians);
    const y = cy + r * Math.sin(radians);
    const largeArcFlag = percent > 50 ? 1 : 0;
    if (percent === 100) {
        // Full circle
        return `M ${cx},${cy - r} A ${r},${r} 0 1,1 ${cx - 0.01},${cy - r} Z`;
    }
    return [
        `M ${cx},${cy}`,
        `L ${cx},${cy - r}`,
        `A ${r},${r} 0 ${largeArcFlag},1 ${x},${y}`,
        'Z'
    ].join(' ');
}

const CircleProgress = ({ percent, size = 24, color = 'var(--main)', bg = '#aaa', padding = 2 }) => {
    // Add padding so the arc doesn't get cut off
    const r = (size - 2 * padding) / 2;
    const cx = size / 2;
    const cy = size / 2;
    return (
        <svg width={size} height={size} className="circle-progress-svg" viewBox={`0 0 ${size} ${size}`}> 
            <circle
                className="circle-progress-bg"
                cx={cx}
                cy={cy}
                r={r}
                fill={bg}
                stroke="none"
            />
            {percent > 0 && (
                <path
                    className="circle-progress-bar"
                    d={describeArc(cx, cy, r, percent)}
                    fill={color}
                />
            )}
        </svg>
    );
};

export default CircleProgress;